import type { Car } from '@ahd/shared/types/ahd-cars/car/car';
import type { Firma } from '@ahd/shared/types/ahd-cars/firma/firma';
import type { FirmaSrr } from '@ahd/shared/types/ahd-cars/firma/srr';

const sVorinformation = (car: Car, idFirma: Firma['i']): FirmaSrr[] => {
    const mangel = [];
    const schaeden = [];
    if (car?.ldmg) {
        for (let i = 0; i < car?.ldmg?.length; i++) {
            const dmg = car?.ldmg[i];
            if (dmg?.typ === 0) mangel?.push(dmg);
            else schaeden?.push(dmg);
        }
    }
    /** * Es darf nur filterAnd ODER filterOr genutzt werden !!!                                         ***/
    /** * 'field' 'operator' 'value' müssen true sein damit das Objekt mit diesem Filter angezeigt wird  ***/
    /** *    5       >=        4            true                                                         ***/
    /** * Bei filterAnd müssen alle Fälle true sein                                                      ***/
    /** * Bei filterOr muss nur ein Fall true sein                                                       ***/

    /* Operatoren : '==='  '!=='  '>'  '>='  '<'  '<='    */

    /*
    filterAnd: [
        {
            field: mangel?.length,
            operator: '>',
            value: 0
        },
        {
            field: schaeden?.length,
            operator: '>',
            value: 0
        }
    ],
    filterOr: [],
    */

    return [
        {
            key: 'arrPos0',
            textV: 'Die Verjährung für Ansprüche aus $ 437 BGB wegen Sachmängeln, mit Ausnahme von Ansprüchen wegen der Verletzung von Gesundheit, Leib oder Leben sowie wegen Schäden, die grob fahrlässig oder vorsätzlich herbeigeführt wurden, vom gesetzlichen Regelzeitraum von zwei Jahren auf, gesetzlich zulässig, ein Jahr verkürzt wird.',
            textAB: 'Die Verjährung für Ansprüche aus $ 437 BGB wegen Sachmängeln, mit Ausnahme von Ansprüchen wegen der Verletzung von Gesundheit, Leib oder Leben sowie wegen Schäden, die grob fahrlässig oder vorsätzlich herbeigeführt wurden, vom gesetzlichen Regelzeitraum wird von zwei Jahren auf, gesetzlich zulässig, ein Jahr verkürzt.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos1',
            textV: 'Die Aktualisierungspflicht für alle digitalen Elemente entgegen der gesetzlichen Grundregel ausgeschlossen wird und der Verkäufer keinen aktuellen Softwaredatenstand schuldet.',
            textAB: 'Die Aktualisierungspflicht wird für alle digitalen Elemente entgegen der gesetzlichen Grundregel ausgeschlossen. Der Verkäufer schuldet keinen aktuellen Softwaredatenstand.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos13',
            textV: 'Ausschluss der Beweislastumkehr beim Verkauf „digitaler Produkte“ im Sinne der §§ 327 ff BGB wegen fehlender Kompatibilität der digitalen Umgebung des Verbrauchers\n\nIch habe klare, verständliche und umfassende Informationen erhalten über: Die technischen Anforderungen des digitalen Produkts an die bei mir vorhandene digitale Umgebung\n\nUnter „digitaler Umgebung“ ist sowohl die bei mir vorhandene Hard- und Software zu versehen als auch Netzverbindungen aller Art.\n\nDie Erbringung notwendiger und mir möglicher Mitwirkungshandlungen, die dem Verkäufer die Feststellung ermöglichen, ob der von mir reklamierte Mangel oder Defekt darauf zurückzuführen ist, dass meine digitale Umgebung zur maßgeblichen Zeit mit den technischen Anforderungen des digitalen Produkts kompatibel war oder nicht.\nDie Obliegenheit zur Erbringung derartiger Mitwirkungshandlungen meinerseits besteht nur für den Fall, dass der Verkäufer zur Feststellung ein technisches Mittel einsetzen will, das für mich den geringsten Eingriff darstellt.',
            textAB: '',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [],
            showV: true,
            showAB: false,
        },
        {
            key: 'arrPos2',
            textV:
                'vereinbart wird, dass es sich bei dem Fahrzeug um einen Gebrauchtwagen mit laufleistungsbedingten Gebrauchsspuren handelt.\n' +
                '\nvereinbart wird, dass Gewährleistungsansprüche nur bei der verkaufenden Firma bestehen und Transport und Wegekosten nicht übernommen werden.\n' +
                '\nvereinbart wird, dass die Bordunterlagen, Hutablage oder Kofferraumabdeckung nicht zum Fahrzeugumfang gehören und ggf. fehlen können.',
            textAB: 'Es handelt sich bei dem Fahrzeug um einen Gebrauchtwagen mit laufleistungsbedingten Gebrauchsspuren. Gewährleistungsansprüche bestehen nur bei der verkaufenden Firma und Transport und Wegekosten werden nicht übernommen. Die Bordunterlagen, Hutablage oder Kofferraumabdeckung gehören nicht zum Fahrzeugumfang und können ggf. fehlen.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: idFirma,
                    operator: '!==',
                    value: 13890 /* 13890 Liliensiek */,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos3',
            textV: 'vereinbart wird, dass, sollte der Käufer ein anderes Fahrzeug besichtigt haben oder zur Probe gefahren sein, als er erwirbt, die Ausstattung des gekauften Fahrzeugs zu der des besichtigten / Probe gefahrenen Fahrzeugs abweichen kann.',
            textAB: 'Sollte der Käufer ein anderes Fahrzeug besichtigt haben oder zur Probe gefahren sein, als er erwirbt, wird vereinbart, dass die Ausstattung des gekauften Fahrzeugs zu der des besichtigten / Probe gefahrenen Fahrzeugs abweichen kann.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos4',
            textV: 'vereinbart wird, dass folgende Sachmängel am Fahrzeug vorhanden sind:',
            textAB: 'Am Fahrzeug sind folgende Sachmängel vorhanden:',
            sig: true,
            mangel: true,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: mangel?.length,
                    operator: '>',
                    value: 0,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos5',
            textV: 'folgende Sondernutzung durch den/die Vorbesitzer des Fahrzeuges vereinbart wird',
            textAB: 'Das Fahrzeug unterlag folgender Sondernutzung durch den/die Vorbesitzer:',
            sig: true,
            mangel: false,
            sondernutzung: true,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: car?.bfs,
                    operator: '===',
                    value: true,
                },
                {
                    field: car?.bmw,
                    operator: '===',
                    value: true,
                },
                {
                    field: car?.btx,
                    operator: '===',
                    value: true,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos6',
            textV: 'vereinbart wird, dass am Fahrzeug folgende Unfallschäden instandgesetzt worden sind:',
            textAB: 'Am Fahrzeug sind folgende Unfallschäden instandgesetzt worden:',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: true,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: schaeden?.length,
                    operator: '>',
                    value: 0,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos7',
            textV: 'vereinbart wird, dass es sich bei dem Fahrzeug um ein Importfahrzeug handelt, bei dem die Ausstattung vom deutschen Fahrzeug abweichen kann. Es wird weiterhin vereinbart, dass die Sprache der Bordliteratur der Sprache des ursprünglich vorgesehenen Auslieferungslandes des Importfahrzeugs entspricht und der Beginn der Werksgarantie vor der Erstzulassung des Fahrzeuges liegen kann.',
            textAB: 'Bei dem Fahrzeug handelt es sich um ein Importfahrzeug, bei dem die Ausstattung vom deutschen Fahrzeug abweichen kann. Die Sprache der Bordliteratur entspricht der Sprache des ursprünglich vorgesehenen Auslieferungslandes des Importfahrzeugs, der Beginn der Werksgarantie kann vor der Erstzulassung des Fahrzeuges liegen.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: ['import'],
            filterAnd: [],
            filterOr: [],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos8',
            textV: 'darüber hinaus vereinbart wird, dass Instandsetzungen und Nachlackierungen im Zuge der Verkaufsaufbereitung vorhanden sein können.',
            textAB: 'Instandsetzungen und Nachlackierungen im Zuge der Verkaufsaufbereitung können vorhanden sein.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: idFirma,
                    operator: '!==',
                    value: 13890 /* 13890 Liliensiek */,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos9',
            textV:
                'vereinbart wird, dass es sich bei dem Vertragsgegenstand um ein Bastler-Fahrzeug mit Mängeln an Motor, Getriebe, Antriebseinheit, Nebenaggregaten, Karosserie, Fahrwerk, Brems- und Auspuffanlage, Mängeln aus vorhandenen und früheren Unfallschäden, sowie Korrosionsschäden handelt, welches nicht zulassungsfähig und nicht fahrbereit ist.\n' +
                '\nvereinbart wird, dass das Fahrzeug ist nicht garantie- und gewährleistungsfähig ist und Sachmangelhaftungen ausgeschlossen sind.\n' +
                '\nvereinbart wird, dass das Fahrzeug technisch und optisch am Ende der Lebensdauer angelangt ist und rein zur Ersatzteilgewinnung dient.',
            textAB: 'Beim Vertragsgegenstand handelt es sich um ein Bastler-Fahrzeug mit Mängeln an Motor, Getriebe, Antriebseinheit, Nebenaggregaten, Karosserie, Fahrwerk, Brems- und Auspuffanlage, Mängeln aus vorhandenen und früheren Unfallschäden, sowie Korrosionsschäden, welches nicht zulassungsfähig und nicht fahrbereit ist. das Fahrzeug ist nicht garantie- und gewährleistungsfähig ist und Sachmangelhaftungen sind ausgeschlossen. Das Fahrzeug ist technisch und optisch am Ende der Lebensdauer angelangt und dient rein zur Ersatzteilgewinnung.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: car?.v,
                    operator: '===',
                    value: 5,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos10',
            textV: 'vereinbart wird, dass Aufgrund unregelmäßiger Wartungen der Hersteller Garantieleistungen, welche im kausalen Zusammenhang mit dem Wartungsversäumnis stehen, verweigern kann.',
            textAB: 'Aufgrund unregelmäßiger Wartungen kann der Hersteller Garantieleistungen, welche im kausalen Zusammenhang mit dem Wartungsversäumnis stehen, verweigern.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: idFirma,
                    operator: '!==',
                    value: 13890 /* 13890 Liliensiek */,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos11',
            textV: 'vereinbart wird, dass die Verkaufspreise für gebrauchte Sommer-/ Winterräder ohne Reifendruckkontrollsysteme angegeben werden. Das Reifendruckkontrollsystem wird auf Kundenwunsch extra in Rechnung gestellt.',
            textAB: 'Die Verkaufspreise für gebrauchte Sommer-/ Winterräder werden ohne Reifendruckkontrollsysteme angegeben. Das Reifendruckkontrollsystem wird auf Kundenwunsch extra in Rechnung gestellt.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: idFirma,
                    operator: '!==',
                    value: 13890 /* 13890 Liliensiek */,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos12',
            textV: 'vereinbart wird, dass das Fahrzeug nicht über folgende Ausstattung verfügt.',
            textAB: 'Das Fahrzeug verfügt nicht über folgende Ausstattung:',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: true,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: car?.minAttr?.length,
                    operator: '>',
                    value: 0,
                },
            ],
            showV: true,
            showAB: true,
        },
        {
            key: 'arrPos13',
            textV: 'vereinbart wird, dass das Produktionsdatum des Fahrzeugs mehr als 12 Monate vor dem Datum der Erstzulassung zurückliegen und das Fahrzeug Lagerhaltungsspuren aufweisen kann.',
            textAB: 'Das Produktionsdatum des Fahrzeugs kann mehr als 12 Monate vor dem Datum der Erstzulassung liegen, das Fahrzeug kann Lagerhaltungsspuren aufweisen.',
            sig: true,
            mangel: false,
            sondernutzung: false,
            schaden: false,
            aus: false,
            filter: [],
            filterAnd: [],
            filterOr: [
                {
                    field: idFirma,
                    operator: '!==',
                    value: 13890 /* 13890 Liliensiek */,
                },
            ],
            showV: true,
            showAB: true,
        },
    ];
};

export default sVorinformation;
